import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    FormControlLabel,
    IconButton,
    List,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Modal,
    Popover,
    Stack,
    Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import StarFilledIcon from 'Components/Icons/StarFilledIcon';
import QuestionCheckboxIcon from 'Components/Icons/QuestionCheckboxIcon';
import QuestionCheckboxCheckedIcon from 'Components/Icons/QuestionCheckboxCheckedIcon';
import TrashIcon from 'Components/Icons/TrashIcon';
import { useDispatch, useSelector } from 'react-redux';
import {
    setActionType,
    setAllChecked,
    setItems,
    setModalOpen,
    setModalType,
    setReload,
    setSelectedItems
} from 'store/ResponseTemplate/actions';
import { useMutation } from '@apollo/client';
import { SET_LOADING, SET_TOAST_OBJECT } from 'store/actions';
import { UPDATE_QUESTION_REGISTRY } from 'schemas/mutation';
import { checkIsPremiumPlan } from 'helper/checkPlan.helper';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '570px',
    bgcolor: '#fff',
    borderRadius: '12px',
    p: 3
};

const QuestionCardInformation = () => {
    const dispatch = useDispatch();
    const { allQuestionRegistries, isAllChecked, userSelectedItems, reload, items } = useSelector((params) => params.response);
    const { companyData } = useSelector((params) => params.customization);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [isStarred, setIsStarred] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [updateRegistry] = useMutation(UPDATE_QUESTION_REGISTRY);

    const filteredFromStarredAndUnstarred = () => {
        let flag = isStarred;

        if (userSelectedItems.length) {
            const isOneStarred = userSelectedItems.filter((item) => item?.starred === false);
            if (isOneStarred.length) {
                flag = false;
            } else {
                flag = true;
            }
        } else {
            flag = false;
        }

        setIsStarred(flag);
    };

    useEffect(() => {
        filteredFromStarredAndUnstarred();
    }, [userSelectedItems]);

    const handleOpenModal = () => {
        // setOpenModal(true);
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: 'delete' });
        dispatch({ type: setActionType, typeOfAction: 'A' });
    };
    const handleCloseModal = () => setOpenModal(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAllChecked = () => {
        dispatch({ type: setSelectedItems, userSelectedItems: isAllChecked ? [] : allQuestionRegistries });
        dispatch({ type: setAllChecked, isAllChecked: !isAllChecked });
    };

    const handleInfo = () => {
        setIsOpen(false);
        dispatch({ type: setSelectedItems, userSelectedItems: [] });
        dispatch({ type: setAllChecked, isAllChecked: false });
    };

    const openPopover = Boolean(anchorEl);
    const id = openPopover ? 'questions-all-delete-popover' : undefined;

    const findAndUpdateStarred = (ids, status) => {
        const newItems = items?.map((item) => {
            // if (item._id === id) {
            //     return { ...item, starred: status };
            // }
            // console.log('Items', item);
            // console.log('IDS', ids);

            if (ids.includes[item?._id]) {
                return { ...item, starred: status };
            }
            return item;
        });

        dispatch({ type: setItems, items: newItems });
    };

    const updateStatus = async (status) => {
        let registryIdsInput = [...userSelectedItems.map((item) => item._id)];

        // console.log('Status', status);

        // console.log('Type of', typeof registryIdsInput);
        // console.log('Reg id', registryIdsInput);

        let variables = {
            editQuestionRegistryInput: {
                questionRegistryIds: registryIdsInput,
                companyId: companyData._id,
                status
            }
        };
        dispatch({ type: SET_LOADING, loading: true });
        dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: false } });

        try {
            await updateRegistry({
                variables: { ...variables }
            });
            // await findAndUpdateStarred(registryIdsInput, status);
            dispatch({ type: setReload, reload: !reload });
            // if (status === 'restored')
            //     dispatch({
            //         type: SET_TOAST_OBJECT,
            //         toastObject: {
            //             status: true,
            //             message: `Question recovered successfully.`,
            //             variant: 'success'
            //         }
            //     });
            dispatch({ type: setSelectedItems, userSelectedItems: [] });
            dispatch({ type: setAllChecked, isAllChecked: false });
        } catch (e) {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    message: e.message || 'Something went wrong. Please try again later.',
                    variant: 'error'
                }
            });
        } finally {
            dispatch({ type: SET_LOADING, loading: false });
        }
    };

    if (!userSelectedItems.length && !isOpen) return '';
    return (
        <>
            <Stack
                sx={{
                    position: 'fixed',
                    bottom: '24px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '100%',
                    maxWidth: '680px',
                    margin: '0 auto',
                    background: '#23282E',
                    borderRadius: '12px',
                    boxShadow: '1px 1px 4px 0px rgba(0, 5, 124, 0.13)',
                    padding: '12px 0'
                }}
            >
                <Stack direction="row" justifyContent="space-between" px={2} alignItems="center">
                    <Stack direction="row" alignItems="center" gap={2}>
                        <IconButton
                            sx={{
                                padding: '0',
                                svg: {
                                    path: {
                                        fill: '#fff'
                                    }
                                },
                                '&:hover': {
                                    svg: {
                                        path: {
                                            fill: '#FBB414'
                                        }
                                    }
                                }
                            }}
                            onClick={handleInfo}
                        >
                            <CloseRoundedIcon />
                        </IconButton>
                        <Typography color="#fff" fontWeight="500" fontSize="0.874rem">
                            {userSelectedItems.length} selected
                        </Typography>
                    </Stack>
                    <Stack
                        sx={{
                            '.MuiTypography-root': {
                                fontWeight: '500',
                                fontSize: '0.874rem',
                                color: '#fff',
                                marginLeft: '4px'
                            }
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    onClick={handleAllChecked}
                                    checked={isAllChecked}
                                    icon={<QuestionCheckboxIcon />}
                                    checkedIcon={<QuestionCheckboxCheckedIcon />}
                                />
                            }
                            label="Select all"
                            disableRipple
                            sx={{
                                '&:hover': {
                                    svg: {
                                        path: {
                                            fill: '#FBB414'
                                        }
                                    },
                                    '.MuiTypography-root': {
                                        color: '#FBB414'
                                    }
                                }
                            }}
                        />
                    </Stack>
                </Stack>
                <Divider
                    sx={{
                        margin: '8px 0',
                        borderColor: 'rgba(255, 255, 255, 0.25)'
                    }}
                />
                <Stack
                    direction="row"
                    px={2}
                    alignItems="center"
                    gap={0.5}
                    sx={{
                        '.MuiIconButton-root': {
                            padding: '0',
                            svg: {
                                path: {
                                    fill: '#fff'
                                }
                            },
                            '&.active': {
                                svg: {
                                    path: {
                                        fill: '#FBB414'
                                    }
                                }
                            }
                        }
                    }}
                >
                    {checkIsPremiumPlan(companyData?.subscription?.plan) && (
                        <>
                            <IconButton
                                onClick={() => updateStatus(isStarred ? 'unstarred' : 'starred')}
                                className={isStarred ? 'active' : ''}
                                sx={{
                                    '&:hover': {
                                        svg: {
                                            path: {
                                                fill: '#FBB414'
                                            }
                                        },
                                        '.MuiTypography-root': {
                                            color: '#FBB414'
                                        }
                                    }
                                }}
                            >
                                <StarFilledIcon />
                                <Typography
                                    color="#fff"
                                    fontWeight="500"
                                    fontSize="0.874rem"
                                    sx={{ marginRight: '12px', marginLeft: '4px' }}
                                >
                                    Star
                                </Typography>
                            </IconButton>
                        </>
                    )}
                    <IconButton
                        className="three-dots"
                        onClick={handleClick}
                        disableRipple
                        sx={{
                            '&:hover': {
                                svg: {
                                    path: {
                                        fill: '#FBB414'
                                    }
                                }
                            }
                        }}
                    >
                        <MoreHoriz className="dot" />
                    </IconButton>
                </Stack>
            </Stack>
            <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                className="question-all-delete-popover"
                sx={{
                    width: '200px'
                }}
            >
                <Box className="popover-wrap">
                    <List>
                        <MenuItem onClick={handleOpenModal} disableRipple>
                            <ListItemIcon>{<TrashIcon />}</ListItemIcon>
                            <ListItemText>Delete questions</ListItemText>
                        </MenuItem>
                    </List>
                </Box>
            </Popover>
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack gap={4}>
                        <Typography variant="h6" component="h2" color="#00214D" fontSize="1.25rem" fontWeight="400" fontFamily="Poppins">
                            Delete all selected questions?
                        </Typography>
                        <Typography component="p" fontSize="0.875rem" color="#00214D">
                            All selected questions will move to the Deleted tab. Questions in the Deleted tab for over 60 days will be
                            permanently removed and cannot be recovered.
                        </Typography>

                        <Stack direction="row" justifyContent="flex-end" gap="10px">
                            <Button
                                variant="outlined"
                                startIcon={<TrashIcon />}
                                sx={{
                                    border: '1px solid #FF3E4A',
                                    color: '#FF3E4A',

                                    '&:hover': {
                                        background: '#FF3E4A',
                                        borderColor: '#FF3E4A',
                                        color: '#fff',

                                        svg: {
                                            path: {
                                                fill: '#fff'
                                            }
                                        }
                                    }
                                }}
                            >
                                Delete
                            </Button>
                            <Button className="alternate" onClick={handleCloseModal}>
                                Keep Questions
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </>
    );
};

export default QuestionCardInformation;
